export const bulkOrderCategory = 'bulk'
export const viewProductAction = 'view product'
export const bulkCartAttributeKey = 'usedBulk'
export const BULK_COLLECTION_HANDLE = 'bulk-order-collection'
export const GENDER_QUERY_PARAM = 'gender'
